import React from 'react';
import { IncludedRelationshipProvider } from 'Views/Page/Contexts/IncludedRelationshipContext';
import PropTypes from 'prop-types';
import Container from './Container';

const SummaryWrapper = ({ relationship }) => {
  return (
    <IncludedRelationshipProvider
      relationship={relationship}
    >
      <Container />
    </IncludedRelationshipProvider>
  );
};

SummaryWrapper.propTypes = {
  relationship: PropTypes.object.isRequired,
};

export default SummaryWrapper;
